import { type FunctionComponent, useMemo } from 'react';

import { UserType } from '@kanda-libs/ks-frontend-services';

export interface CompanyUsersModalUserCardProps {
  user: UserType;
  onClick: (user: UserType) => void;
}

const CompanyUsersModalUserCard: FunctionComponent<CompanyUsersModalUserCardProps> =
  function ({ user, onClick }) {
    const name = useMemo(
      () => [user.first_name, user.last_name].filter(Boolean).join(' '),
      [user],
    );

    return (
      <button
        type="button"
        id="select-user"
        onClick={() => onClick(user)}
        className="flex flex-col p-3 border border-neutral-300 rounded shadow-card text-14-22"
      >
        <div className="grid grid-cols-[min-content_auto] gap-x-3 gap-y-2 text-left">
          <p className="text-14-22-em text-neutral-700">Name:</p>
          <p className="text-14-22">{name}</p>
          <p className="text-14-22-em text-neutral-700">Email:</p>
          <p className="text-14-22">{user.email}</p>
          <p className="text-14-22-em text-neutral-700">Mobile:</p>
          <p className="text-14-22">{user.mobile}</p>
        </div>
      </button>
    );
  };

export default CompanyUsersModalUserCard;
